import { settingResource, SettingResource } from '@witkac/kartamiejska-resources';
import { Setting, SettingValueType } from '@witkac/kartamiejska-shared';
import Vue from 'vue';

import { EntityModule } from './entity.module';

const JSONValues = [SettingValueType.JSON, SettingValueType.CATEGORIES, SettingValueType.CATEGORIES];
/**
 * Moduł ustawień
 *
 * @export
 * @class SettingsModule
 */
export class SettingsModule extends EntityModule<Setting, SettingResource> {
  /**
   * Czy ma być używany namespace
   *
   * @type {boolean}
   * @memberof SettingsModule
   */
  public namespaced: boolean = true;

  /**
   * Stan store
   *
   * @type {object}
   * @memberof SettingsModule
   */
  public state: any = {};

  public mutations = {
    /**
     * Zapisuje dane profilu do store
     *
     * @param localState state
     * @param data dane ustawienia
     */
    set(localState: any, data: Setting): void {
      if (
        data &&
        data.value &&
        typeof data.value === 'string' &&
        JSONValues.includes(data.valueType as SettingValueType)
      ) {
        data.value = JSON.parse(data.value);
      }
      Vue.set(localState, data.code, data);
    }
  };

  public actions = {
    /**
     * Pobiera ustawienie jeżeli jeszcze nie zostało załadowane
     *
     * @param context context
     * @param id identyifkator encji
     */
    get: async (context: any, code: string): Promise<Setting> => {
      if (context.state[code] !== undefined) {
        return context.state[code];
      }
      const response = await this.resource.settingFindPublic(code);
      context.commit('set', response);
      return response;
    }
  };
}

export default new SettingsModule(settingResource);
